<template>
	<div class="link-dropdown-item" @click="handleClick" :class="[`link-dropdown-item-${align}`,{'link-dropdown-item-disabled':lv_disabled,'link-dropdown-item-active':active}]">
		<slot>
			<link-icon :icon="icon" style="margin-right: 0.25em" v-if="!!icon"/>
			<span>{{label}}</span>
		</slot>
	</div>
</template>

<script>
	import {findComponentUpward} from 'src/utils/dom';

	export default {
		name: "link-dropdown-item",
		props: {
			label: {},
			disabled: {type: [Boolean, Function]},
			availableTimes: {type: Number},
			align: {type: String, default: 'center'},
			active: {type: Boolean},
			icon: {},
		},
		watch: {
			disabled(val) {
				if (this.$lv.$utils.typeOf(val) === 'function') {
					val = val()
				}
				this.lv_disabled !== val && (this.lv_disabled = val)
			},
			lv_disabled(val) {
				this.disabled !== val && this.$emit('update:disabled', val)
			},
		},
		data() {
			let disabled = this.disabled;
			if (this.$lv.$utils.typeOf(this.disabled) === 'function') {
				disabled = disabled()
			}
			return {
				dropdown: null,
				lv_disabled: disabled,
				clickTimes: 0,
			}
		},
		methods: {
			handleClick(e) {
				if (!!this.lv_disabled) return
				if (!!this.dropdown && !!this.dropdown.hideOnClickItem) this.dropdown.hide()
				this.$emit('click', e)
				this.clickTimes++
				if (this.clickTimes === this.availableTimes) this.lv_disabled = true
			},
		},
		mounted() {
			this.dropdown = findComponentUpward(this, 'link-dropdown')
		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-dropdown-item {
			display: flex;
			flex-wrap: nowrap;

			&.link-dropdown-item-flex-start {
				justify-content: flex-start;
			}

			&.link-dropdown-item-center {
				justify-content: center;
			}

			&.link-dropdown-item-flex-end {
				justify-content: flex-end;
			}

			&.link-dropdown-item-space-between {
				justify-content: space-between;
			}

			&.link-dropdown-item-space-evenly {
				justify-content: space-evenly;
			}

			&.link-dropdown-item-space-around {
				justify-content: space-around;
			}

			&.link-dropdown-item-disabled {
				color: $placeholder-color;
				cursor: not-allowed;
				background-color: white !important;
			}
		}
	}
</style>
